import { z } from "zod"

export const billingPeriodRepresentationSchema = z.object({
  /**
   * The number of days to add to a Genability-style fromDate
   * to obtain the LSE's start of a billing period.
   */
  fromDateOffset: z.number().int(),
  /**
   * The number of days to add to a Genability-style toDate to
   * obtain the LSE's end of a billing period.
   */
  toDateOffset: z.number().int(),
  /**
   * Our name for this particular style of a Billing Period Representation.
   */
  style: z.string(),
})

export type BillingPeriodRepresentation = z.infer<
  typeof billingPeriodRepresentationSchema
>
